import styled from 'styled-components';

const ButtonsWrap = styled.div`
  display: flex;
  margin: 0 30px 0 auto;
`;

export default ButtonsWrap;
